import { z } from 'zod';
import { minimalUserSchema } from './user';

// not a db 1-1 mapping
const rawFlattenedIssueTypeSchema = z.object({
  issue_type_id: z.string().nullable(),
  issue_type_name: z.string().nullable(),
  issue_subtype_id: z.string().nullable(),
  issue_subtype_name: z.string().nullable(),
  created_at: z.number().transform((date) => new Date(date).toISOString()),
  path: z.string(),
  created_by: z.string().nullable(),
  managers: z.array(minimalUserSchema).nullable(),
  organization_id: z.string(),
});

type RawFlattenedIssueTypeSchema = z.infer<typeof rawFlattenedIssueTypeSchema>;

const flattenedIssueTypeSchemaTransformer = (
  issueType: RawFlattenedIssueTypeSchema,
) => ({
  issueTypeId: issueType.issue_type_id,
  issueTypeName: issueType.issue_type_name,
  issueSubtypeId: issueType.issue_subtype_id,
  issueSubtypeName: issueType.issue_subtype_name,
  path: issueType.path,
  // the three of them will be the same
  createdAt: issueType.created_at,
  createdBy: issueType.created_by,
  managers: issueType.managers,
  organizationId: issueType.organization_id,
});

export const flattenedIssueTypeSchema = rawFlattenedIssueTypeSchema.transform(
  flattenedIssueTypeSchemaTransformer,
);

export type FlattenedIssueTypeEntity = z.infer<typeof flattenedIssueTypeSchema>;
